import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwipeActionComponent } from './swipe-action.component';

@NgModule({
  imports: [CommonModule],
  exports: [SwipeActionComponent],
  declarations: [SwipeActionComponent],
  providers: []
})
export class SwipeActionModule {}
